import React from 'react';
import { RouteManager as Route } from 'component/_structure/routeManager';
import { Router, Switch, Redirect, useLocation } from 'react-router-dom';
import Home from 'pages/site/home/home.component';
import Article from 'pages/admin/article/article.component';
import ArticleList from 'pages/admin/article/articleList.component';
import AdminPage from 'pages/admin/admin.page.component';
import Template from 'pages/admin/template/Register';
import TemplateList from 'pages/admin/template/list/templateList.component';
import ResumeClipping from 'pages/site/clipping/resume/clipping.resume.admin.component';
import history from 'config/history';

export default function RouteAdminMapper() {
  return (
    <Router history={history} location={useLocation}>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/admin" component={AdminPage} />
        <Route exact path="/admin/artigo" component={Article} />
        <Route exact path="/admin/artigo/edicao/:id" component={Article} />
        <Route exact path="/admin/listaArtigos" component={ArticleList} />
        <Route exact path="/admin/template" component={Template} />
        <Route exact path="/admin/template/edicao/:id" component={Template} />
        <Route exact path="/admin/listaTemplates" component={TemplateList} />
        <Route
          exact
          path="/admin/acompanhar-agenda"
          component={ResumeClipping}
        />
        <Redirect to="/" />
      </Switch>
    </Router>
  );
}
